import { isEmpty } from 'lodash'
import { createStore } from 'zustand'

import { toArray } from '@eastcoal/common/utils/array'

import { resolveChangedValue } from '../../utils/resolveChangedValue'

import { CertificationsStore } from './interface'

export const createCertificationsStore = () =>
  createStore<CertificationsStore>((set, get) => ({
    currentCertification: undefined,
    value: undefined,
    onChange: undefined,
    certificationFormVisible: false,
    setCurrentCertification(certification) {
      set({ currentCertification: certification })
    },
    setValues(certifications) {
      const { value: originCertifications, onChange } = get()

      const newCertifications = isEmpty(originCertifications)
        ? toArray(certifications)
        : resolveChangedValue(originCertifications, certifications)

      onChange?.(newCertifications)
      set({ value: newCertifications })
    },
    deleteCertification(value) {
      const { value: certifications, onChange } = get()
      const finalCertifications = certifications?.filter(
        item => item.id !== value?.id
      )

      onChange?.(finalCertifications)
      set({ value: finalCertifications })
    },
    toggleCertificationFormVisible() {
      const { certificationFormVisible, setCurrentCertification } = get()

      const visible = !certificationFormVisible

      set({ certificationFormVisible: visible })

      if (!visible) {
        setCurrentCertification(undefined)
      }
    }
  }))
